import api from '@/utils/api';

/**
 * Create a Dealer's price
 * @param {string} companyId selected company id
 * @param {object} priceData - The price data
 * @returns {Promise}
 */
const createDealerPriceApi = (companyId, priceData) =>
  api.post(`/company/${companyId}/price/add-price`, priceData);

export default createDealerPriceApi;
